import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import Home from "./pages/Home";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Industries from "./pages/Industries";
import Resources from "./pages/Resources";
import Article from "./pages/Article";
import ThankYou from "./pages/ThankYou";
import Fundraising from "./pages/Fundraising";

import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import { Toaster } from "./components/ui/sonner";

import {
  FundraisingAssistance,
  InvestorDiscovery,
  InvestorOutreach,
  DataRoom,
  PitchDeck,
  FinancialModeling,
  StartupScouting,
  StartupMatchmaking,
  InvestorFundraising,
  StrategicAcquisition,
  EarlyStage,
  GrowthStage,
  LateStage,
  HNIAngel,
  MicroVCs,
  FamilyOffices,
  PrivateEquity,
  CorporateInvestors
} from "./pages/SubPages";

import {
  Career,
  Reviews,
  CaseStudies,
  Terms,
  Privacy,
  Refund,
  ForInvestors,
  ForStartups
} from "./pages/MorePages";


const Layout = ({ children }) => {
  const location = useLocation();

  const isAdmin = location.pathname.startsWith("/admin");

  useEffect(() => {
    const canonicalUrl =
      `https://founderscalecapital.com${location.pathname}`;

    let canonical =
      document.querySelector('link[rel="canonical"]');

    if (!canonical) {
      canonical = document.createElement("link");

      canonical.setAttribute(
        "rel",
        "canonical"
      );

      document.head.appendChild(canonical);
    }

    canonical.setAttribute(
      "href",
      canonicalUrl
    );
  }, [location.pathname]);

  return (
    <>
      {!isAdmin && <Header />}

      {children}

      {!isAdmin && <Footer />}
    </>
  );
};


function App() {
  return (
    <div className="App">

      <BrowserRouter>

        <ScrollToTop />

        <Layout>

          <Routes>

            {/* ========================= */}
            {/* MAIN PAGES */}
            {/* ========================= */}

            <Route
              path="/"
              element={<Home />}
            />

            <Route
              path="/fundraising"
              element={<Fundraising />}
            />

            <Route
              path="/thank-you"
              element={<ThankYou />}
            />

            <Route
              path="/services"
              element={<Services />}
            />

            <Route
              path="/about"
              element={<About />}
            />

            <Route
              path="/industries"
              element={<Industries />}
            />

            <Route
              path="/resources"
              element={<Resources />}
            />

            <Route
              path="/resources/:slug"
              element={<Article />}
            />

            <Route
              path="/contact"
              element={<Contact />}
            />


            {/* ========================= */}
            {/* STARTUP PAGES */}
            {/* ========================= */}

            <Route
              path="/for-startups"
              element={<ForStartups />}
            />

            <Route
              path="/services/fundraising-assistance"
              element={<FundraisingAssistance />}
            />

            <Route
              path="/services/investor-discovery"
              element={<InvestorDiscovery />}
            />

            <Route
              path="/services/investor-outreach"
              element={<InvestorOutreach />}
            />

            <Route
              path="/services/data-room"
              element={<DataRoom />}
            />

            <Route
              path="/services/pitch-deck"
              element={<PitchDeck />}
            />

            <Route
              path="/services/financial-modeling"
              element={<FinancialModeling />}
            />


            {/* ========================= */}
            {/* INVESTOR PAGES */}
            {/* ========================= */}

            <Route
              path="/for-investors"
              element={<ForInvestors />}
            />

            <Route
              path="/for-investors/startup-scouting"
              element={<StartupScouting />}
            />

            <Route
              path="/for-investors/startup-matchmaking"
              element={<StartupMatchmaking />}
            />

            <Route
              path="/for-investors/fundraising-assistance"
              element={<InvestorFundraising />}
            />

            <Route
              path="/for-investors/strategic-acquisition"
              element={<StrategicAcquisition />}
            />


            {/* ========================= */}
            {/* STAGE PAGES */}
            {/* ========================= */}

            <Route
              path="/stage/early"
              element={<EarlyStage />}
            />

            <Route
              path="/stage/growth"
              element={<GrowthStage />}
            />

            <Route
              path="/stage/late"
              element={<LateStage />}
            />


            {/* ========================= */}
            {/* INVESTOR TYPE PAGES */}
            {/* ========================= */}

            <Route
              path="/investor-type/hni-angel"
              element={<HNIAngel />}
            />

            <Route
              path="/investor-type/micro-vcs"
              element={<MicroVCs />}
            />

            <Route
              path="/investor-type/family-offices"
              element={<FamilyOffices />}
            />

            <Route
              path="/investor-type/private-equity"
              element={<PrivateEquity />}
            />

            <Route
              path="/investor-type/corporate"
              element={<CorporateInvestors />}
            />


            {/* ========================= */}
            {/* OTHER PAGES */}
            {/* ========================= */}

            <Route
              path="/career"
              element={<Career />}
            />

            <Route
              path="/reviews"
              element={<Reviews />}
            />

            <Route
              path="/case-studies"
              element={<CaseStudies />}
            />


            {/* ========================= */}
            {/* LEGAL PAGES */}
            {/* ========================= */}

            <Route
              path="/terms"
              element={<Terms />}
            />

            <Route
              path="/privacy"
              element={<Privacy />}
            />

            <Route
              path="/refund-policy"
              element={<Refund />}
            />


            {/* ========================= */}
            {/* ADMIN ROUTES */}
            {/* ========================= */}

            <Route
              path="/admin/login"
              element={<AdminLogin />}
            />

            <Route
              path="/admin/dashboard"
              element={<AdminDashboard />}
            />

          </Routes>

        </Layout>

        <Toaster />

      </BrowserRouter>

    </div>
  );
}

export default App;
